/**
 * @file  phonelink/style.ts
 * @description  phone link core element style information
 *
 * @example <PhoneLink  />
 *
 * @author dlima (dlima-electron)
 *
 */
import styled from 'styled-components';

// style props
export interface Props {
  id: string;
  title?: string;
  phone?: string;
  className?: string;
}

export const Link = styled.a<Props>`
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    key={src}
    aria-label={label}
    text-decoration=none        
`;

export const Underline = styled.span`
  text-decoration: underline;
  white-space: nowrap;
`;

export const Nowrap = styled.span`
  white-space: nowrap;
`;
